import React, {useEffect, useState} from 'react';
import { renderDropdown, renderDropdownReadOnly} from "./DropdownFunctions";
import SpinnerDiv from "root/Forms/UI/SpinnerDiv";
import PropTypes from "prop-types";
import {Globals} from "root/DataFunctions/BaseDataFns";
import {genericListboxFetch} from "root/ReactHookForm/ui/DropdownDataProviders";
import {ChildRoles} from "root/DataFunctions/Constants";

const ReactHookFormDropdownLetterboxToContacts = (props) =>
{
    const [ data, setData ] = useState ( { loading: true, items : [] } ) ;

    useEffect(() => {
        if ( props.to_uid !== null )
        {
            //const url = Globals.APIFolder + '/users/' + props.to_uid + '/contacts?user_role=' + ChildRoles.MESSAGER + '&letterbox_users=true&direction=receive' ;
            const url = Globals.APIFolder + '/users/' + props.to_uid + '/relations?direction=from' ;

            setData ( { loading: true, items: [] }) ;

            genericListboxFetch({ url:url, keyFieldName:'user_id', labelFieldName:'name', additionalFields: ['idusers'] }).then((response) =>
            {
                setData ( { loading: false, items: response }) ;
            }) ;
        }
        else
        {
            setData ( { loading: false, items: [] }) ;
        }

    }, [props.to_uid]);

    return data.loading === true ? <SpinnerDiv/> :
    (
        props.readOnly === 'readonly' ? renderDropdownReadOnly(props.value, props.onChange, data.items, { ...props.options, ... {isSearchable: true}}) : renderDropdown(props.value, props.onChange, data.items, { ...props.options, ... {isSearchable: true}})
    )
}

export default ReactHookFormDropdownLetterboxToContacts;

ReactHookFormDropdownLetterboxToContacts.defaultProps =
{
    defaultClassName: ''
}

ReactHookFormDropdownLetterboxToContacts.propTypes = {
    onChange: PropTypes.func.isRequired
};


